module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('wxc-mask', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined)),
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "aria-hidden": "true",
      "mask-bg-color": "transparent",
      "overlay-opacity": "0.8",
      "show": _vm.show,
      "show-close": false
    },
    on: {
      "wxcMaskSetHidden": _vm.maskOverlayClick
    }
  }, [(_vm.show) ? _c('slider', {
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle({
      height: _vm.height + 'px'
    })),
    attrs: {
      "auto-play": "false"
    }
  }, [_vm._l((_vm.imageList), function(v, index) {
    return _c('div', {
      key: index,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle({
        height: _vm.height + 'px'
      }))
    }, [_c('image', {
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle({
        height: _vm.height + 'px',
        width: _vm.width + 'px'
      })),
      attrs: {
        "resize": "cover",
        "src": v.src
      }
    })])
  }), _vm._v(" "), _c('indicator', {
    staticClass: "indicator",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.indicatorStyle))
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f2af058", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f2af058","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-lightbox/index.vue
// module id = 175
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28